import angular from 'angular'

import announceCtrl from './announce.controller'
import announceRoutes from './announce.routes'
import announceRun from './announce.run'

const name = 'routingManeuverAnnounce'

angular.module(name, [

])
  .controller('announceCtrl', announceCtrl)
  .run(announceRun)
  .config(announceRoutes)

export default name



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/maneuver/announce/announce.module.js